import { HttpClient } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { forkJoin } from 'rxjs';
import { SetJobLevels } from '../../store/jobLevel/job-level-action';
import { SetJobLocations } from '../..//store/jobLocation/job-location-action';
import { SetJobStatus } from '../../store/jobStatus/job-status-action';
import { SetJobTypes } from '../../store/jobType/job-type-action';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
  })
export class JobParameterService {
    protected jobTypes: Map<any, any> | undefined;
    protected jobLevels: Map<any, any> | undefined;
    protected jobStatus: Map<any, any> | undefined;
    protected jobLocations: Map<any, any> | undefined;

    constructor(protected httpClient: HttpClient, protected store: Store) {
    }

    async initParam() {
        const sources = [this.updateJobTypes(), this.updateJobLocations(), this.updateJobLevels(), this.updateJobStatus()];
        await forkJoin(sources).toPromise();
    }

    createParamMap(params: any[], idFunc: (param: any) => any, valueFunc: (param: any) => any): Map<any, any> {
        const ret = new Map<any, any>();
        if (params == null || params.length <= 0) {
            return ret;
        }
        for (const param of params) {
            ret.set(idFunc(param), valueFunc(param));
        }
        return ret;
    }

    async updateJobLocations() {
        const result: any = await this.httpClient.get('plan/api/business/job/queryLocations').toPromise();
        if (result.code !== 200 || result.data == null) {
            return;
        }
        this.jobLocations = this.createParamMap(result.data, (param) => param.locationId, (param) => param.locationName);
        this.store.dispatch(new SetJobLocations(result.data));
    }
    async updateJobTypes() {
        const result: any = await this.httpClient.get('plan/api/business/jobType/queryAll').toPromise();
        if (result.code !== 200 || result.data == null) {
            return;
        }
        this.jobTypes = this.createParamMap(result.data, (param) => param.skillId, (param) => param.skillName);
        this.store.dispatch(new SetJobTypes(result.data));
    }

    async updateJobLevels() {
        const result: any = await this.httpClient.get('plan/api/business/jobLevel/queryAll').toPromise();
        if (result.code !== 200 || result.data == null) {
            return;
        }
        this.jobLevels = this.createParamMap(result.data, (param) => param.jlId, (param) => param.jlName);
        this.store.dispatch(new SetJobLevels(result.data));
    }

    async updateJobStatus() {
        const result: any = await this.httpClient.get('plan/api/business/jobStatus/queryAll').toPromise();
        if (result.code !== 200 || result.data == null) {
            return;
        }
        this.jobStatus = this.createParamMap(result.data, (param) => param.dictValue, (param) => param.dictLabel);
        this.store.dispatch(new SetJobStatus(result.data));
    }
}
